import React, { useEffect, useState } from "react";
import {
  Divider,
  Grid,
  Tooltip,
  TextField,
  Alert,
  AlertTitle,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import InputMask from "react-input-mask";
import { cadastroCartao, cadastroSite } from "../../store/actions/cadastro";
import cartoesaceitos from "../../assets/cartoesaceitos.png";
import { BsQuestionCircle } from "react-icons/bs";
import { dia } from "./dates";
import { InputSelect } from "../../components";
import ButtonComponent from "../../components/ButtonComponent";
import { removeDots } from "../../helpers/removeDots";

function CadastroPagamento({ loadActions, planoId = 30, diaVencimento }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { cadastroCartaoLoading } = useSelector((state) => state.cadastro);
  const [data, setData] = useState({
    numero: "",
    titular: "",
    cvv: "",
    mes: "",
    ano: "",
    diaVencimentoFatura: "",
  });
  const [modal, setModal] = useState(false);

  const [errorValidation, setErrorValidation] = useState({
    titular: false,
    numero: false,
    cvv: false,
    mes: false,
    ano: false,
    diaVencimentoFatura: false,
  });

  const [messageError, setMessageError] = useState("");
  const [mensagemProvisoriaDev, setMensagemProvisoriaDev] = useState(false);
  const [largura, setLargura] = useState();

  useEffect(() => {
    const larg = window.screen.width;
    setLargura(larg);
    window.scrollTo(0, 0);
  }, []);

  setTimeout(() => {
    if (mensagemProvisoriaDev) setMensagemProvisoriaDev(false);
  }, 3000);

  async function ConfirmarContratacao() {
    try {
      await cadastroCartao({
        planoId,
        diaVencimentoFatura:
          data.diaVencimentoFatura !== ""
            ? +data.diaVencimentoFatura
            : undefined,
        diaVencimento: diaVencimento,
        formaPagamento: "CREDITO_REC",
        cartaoCredito: {
          numero: removeDots(data.numero),
          titular: data.titular,
          validade: `${data.ano}-${data.mes}`,
          cvv: data.cvv,
        },
      });
      loadActions();
    } catch (e) {
      setModal(false);
      setMensagemProvisoriaDev(true);
      setMessageError(e && e.response.data);
    }
  }

  return (
    <>
      {cadastroCartaoLoading && (
        <Backdrop style={{ background: "rgba(0,0,0,0.6)" }} open={true}>
          <CircularProgress style={{ color: "#84BCC5" }} />
        </Backdrop>
      )}
      <div
        style={{
          width: "90%",
          margin: "auto",
          marginBottom: "5em",
        }}
      >
        <div>
          <div style={{ marginBottom: "2em" }}>
            {" "}
            {messageError && (
              <>
                <Alert severity="error">
                  <AlertTitle style={{ fontSize: 12 }}>
                    {" "}
                    {messageError?.message}{" "}
                  </AlertTitle>

                  <Divider />
                  {messageError &&
                    messageError?.validationError?.map((item) => {
                      return (
                        <div>
                          <li style={{ color: "#a52424" }}>{item.message}</li>
                        </div>
                      );
                    })}
                </Alert>
              </>
            )}
          </div>
          <span
            style={{
              marginBottom: "1em",
              color: "gray",
            }}
          >
            Método de Pagamento
          </span>
          <Divider style={{ marginBottom: "0.5em" }} />
          <Grid
            container
            spacing={1}
            style={{
              fontSize: "12px",
              lineHeight: "2em",
              display: "flex",
              flexDirection: "row",
              alignContent: "center",
              alignItems: "center",
            }}
          >
            <Grid item sm={12} xs={12}>
              Nome do Titular Impresso no Cartão
              <TextField
                value={data.titular}
                fullWidth
                size="small"
                onChange={(e) => setData({ ...data, titular: e.target.value })}
                name="titular"
                inputProps={{ maxlength: 26 }}
              />
              {errorValidation.titular && data.titular?.length < 1
                ? "Digite o nome do titular"
                : ""}
            </Grid>
            <Grid item sm={5} xs={12}>
              Número do Cartão
              <InputMask
                mask="9999 9999 9999 9999"
                value={data.numero}
                onChange={(e) => setData({ ...data, numero: e.target.value })}
              >
                {() => (
                  <TextField
                    placeholder="0000 0000 0000 0000"
                    fullWidth
                    size="small"
                    name="numero"
                  />
                )}
              </InputMask>
              {errorValidation.numero && data.numero?.length < 1
                ? "Digite o número do cartão"
                : ""}
            </Grid>
            <Grid item sm={2} xs={12}>
              CVV
              <InputMask
                mask="999"
                value={data.cvv}
                onChange={(e) => setData({ ...data, cvv: e.target.value })}
              >
                {() => (
                  <TextField
                    placeholder="123"
                    fullWidth
                    size="small"
                    name="cvv"
                  />
                )}
              </InputMask>
              {errorValidation.cvv && data.cvv?.length < 3
                ? "Digite o cvv"
                : ""}
            </Grid>
            <Grid item sm={2} xs={12}>
              Venc. Mês
              <InputSelect
                name="mes"
                values={[
                  { value: "", label: "-" },
                  { value: "01", label: "1" },
                  { value: "02", label: "2" },
                  { value: "03", label: "3" },
                  { value: "04", label: "4" },
                  { value: "05", label: "5" },
                  { value: "06", label: "6" },
                  { value: "07", label: "7" },
                  { value: "08", label: "8" },
                  { value: "09", label: "9" },
                  { value: "10", label: "10" },
                  { value: "11", label: "11" },
                  { value: "12", label: "12" },
                ]}
                value={data.mes}
                onChange={(e) => setData({ ...data, mes: e.target.value })}
              />
              {errorValidation.mes && data.mes?.length < 1
                ? "Digite o mês"
                : ""}
            </Grid>
            <Grid item sm={3} xs={12}>
              Venc. Ano
              <InputSelect
                name="ano"
                values={[
                  { value: "", label: "-" },
                  { value: "2023", label: "2023" },
                  { value: "2024", label: "2024" },
                  { value: "2025", label: "2025" },
                  { value: "2026", label: "2026" },
                  { value: "2027", label: "2027" },
                  { value: "2028", label: "2028" },
                  { value: "2029", label: "2029" },
                  { value: "2030", label: "2030" },
                  { value: "2031", label: "2031" },
                  { value: "2032", label: "2032" },
                  { value: "2033", label: "2033" },
                  { value: "2034", label: "2034" },
                  { value: "2035", label: "2035" },
                ]}
                value={data.ano}
                onChange={(e) => setData({ ...data, ano: e.target.value })}
              />
              {errorValidation.ano && data.ano?.length < 1
                ? "Digite o ano"
                : ""}
            </Grid>

            {!diaVencimento && (
              <Grid item sm={5} xs={12}>
                <div style={{ flexDirection: "row", display: "flex" }}>
                  Vencimento fatura do cartão
                  <Tooltip title="O valor da mensalidade será cobrado 3 dias após o vencimento da sua fatura.">
                    <div style={{ marginLeft: 10 }}>
                      <BsQuestionCircle size={14} color="gray" />
                    </div>
                  </Tooltip>
                </div>
                <InputSelect
                  name="dia"
                  values={dia}
                  value={data.diaVencimentoFatura}
                  onChange={(e) =>
                    setData({ ...data, diaVencimentoFatura: e.target.value })
                  }
                />
                {errorValidation.diaVencimentoFatura &&
                data.diaVencimentoFatura?.length < 1
                  ? "Digite o dia de vencimento"
                  : ""}
              </Grid>
            )}

            <Grid item sm={7} xs={12}>
              Bandeiras aceitas
              <img
                src={cartoesaceitos}
                alt="Bandeiras"
                style={{ width: "100%" }}
              />
            </Grid>
          </Grid>
          <br />
          <h6 style={{ fontSize: "12px", margin: 0 }}>
            Os detalhes do seu cartão serão salvos com segurança para pagamentos
            mais rápidos. Seu CVV não será armazenado.{" "}
          </h6>
          <br />
          <div>
            <ButtonComponent
              fullWidth={true}
              type="submit"
              onClick={() => ConfirmarContratacao()}
            >
              CONFIRMAR CONTRATAÇÃO
            </ButtonComponent>

            {mensagemProvisoriaDev && (
              <Alert severity="warning">
                Não foi possível concluir sua contratação, tente novamente.
              </Alert>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default CadastroPagamento;
